import ActionTypes from "../constants/action_types";

export default function clearDocumentTypes() {
  return {
    type: ActionTypes.DOCUMENT_TYPES_CLEAR.SUCCESS,
  };
}
